import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { describe, PropTypes } from '@amzn/stencil-react-desc';
import { styledWithTheme } from "../../../context";
import { backgroundColorPropTypes } from "../../../prop-types";
import { cssValueProp, withTestAttributes } from "../../../utils";
var OptionBase = styledWithTheme('option')(function (_ref) {
  var backgroundColor = _ref.backgroundColor,
      placeholder = _ref.placeholder,
      theme = _ref.theme;
  var selectors = theme.selectors;

  var styles = _objectSpread(_objectSpread({}, cssValueProp(selectors.colorOrNull, backgroundColor, 'backgroundColor')), {}, {
    whiteSpace: 'pre-wrap',
    wordWrap: 'break-word',
    maxWidth: '100%'
  });

  if (placeholder) {
    // This option is not recommended as placeholder is a part of Select API
    // It is kept here only to reflect html behavior
    styles = _objectSpread(_objectSpread({}, styles), {}, {
      display: 'none',
      color: selectors.color('neutral70')
    });
  }

  return styles;
});
OptionBase.defaultProps = {
  backgroundColor: 'neutral0'
};
var OptionBaseWithDocs = describe(OptionBase).description('Single option inside a Select component.');
OptionBaseWithDocs.propTypes = _objectSpread(_objectSpread({}, backgroundColorPropTypes), {}, {
  children: PropTypes.string.isRequired.description('Text displayed in the dropdown for this option.'),
  value: PropTypes.string.isRequired.description('The value represented by this option, which will be passed in onChange and when the form is submitted.')
});
var Option = withTestAttributes({
  component: 'StencilReactOption'
})(OptionBaseWithDocs);
Option.displayName = 'Option';
export default Option;